import React, { useEffect, useRef, useState } from "react";
import BaseModel from "../models/BaseModel";
import Browser from "../browser";

import Point from "../models/Point";
import { createPortal } from "react-dom";

export function FlyoutHost(props: { flyOutPosition: any; flyOutContent: any; onClose: () => void; flyoutId: string }) {
  const { flyOutPosition, flyOutContent, onClose, flyoutId } = props;
  const refFlyoutHost = useRef<HTMLDivElement>(null);

  const timer = useRef<any>(0);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      const elm = document.getElementById(flyoutId + "tv-flyout");

      if (elm) {
        const r = elm.getBoundingClientRect();
        const h = window.innerHeight + 15;
        if (r.bottom > h) {
          elm.style.transition = "0.5s";
          elm.style.transitionProperty = "top"; // no itx
          elm.style.top = `${h - r.height}px`;
        }
      }
      timer.current = 0;
    }, 100);
  });

  const p = flyOutPosition;

  return (
    <div
      ref={refFlyoutHost}
      style={{
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "100%",
        height: "100%",
        // backdropFilter: "blur(1px)",
        backgroundColor: "rgba(255,255,255,0.3)",
        zIndex: "100",
      }}
      onClick={(ev) => {
        //
        // close flyout !!
        //

        ///
        // force blur on any input before close
        //

        (document.activeElement as any)?.blur();

        setTimeout(() => {
          onClose();
        }, 50);
      }}
    >
      <div
        style={{
          left: `${p?.x ?? 0}px`,
          top: `${p?.y ?? 0}px`,
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onMouseUp={(event) => {
          event.stopPropagation();
        }}
        id={flyoutId + "tv-flyout"}
        className="tvflyout"
      >
        {/* <p>This child is placed in the document body.</p> */}
        {flyOutContent}
      </div>
    </div>
  );
}

export default function FlyoutControl(props: { obj: BaseModel; foc: any }): any {
  const { obj, foc } = props;

  const refI = useRef<HTMLElement>(null);
  const refO = useRef<HTMLDivElement>(null);

  const flyOutPosition = useRef<any>(undefined);

  const [flyoutVisible, setFlyoutVisible] = useState(false);

  const maxWidth = window.innerWidth / 2;

  return (
    <div
      ref={refO}
      className="treeMenuIcon"
      onClick={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const dataline = refO.current?.closest(".dataline"); // no itx
        if (dataline) {
          dataline.classList.remove("firstButtonActive");
          const treeMenuButtons = dataline.querySelector(".treeMenuButtons") as HTMLElement; // no itx
          if (treeMenuButtons) {
            treeMenuButtons.style.visibility = "hidden";
          }
        }

        state.selectionManager.selectedObject = obj;

        const r = refI.current?.getBoundingClientRect();
        if (r) {
          setFlyoutVisible(true);

          const p = new Point(r.right - 30, r.top - 10);
          flyOutPosition.current = p;
        }
      }}
      style={{
        maxWidth: Browser.isMobile() ? window.innerWidth : maxWidth,
      }}
    >
      {flyoutVisible &&
        createPortal(
          <FlyoutHost
            flyOutPosition={flyOutPosition.current}
            flyOutContent={obj.treeViewModel.getFlyoutControl()}
            onClose={() => {
              setFlyoutVisible(false);
            }}
            flyoutId={obj.id + "_"}
          />,
          document.body,
        )}

      <i
        ref={refI}
        style={{
          color: "black",
          borderRadius: "15px",
          pointerEvents: "auto",
        }}
        className={`las la-ellipsis-v`}
      ></i>
    </div>
  );
}
